import { createContext, useCallback, useContext, useState } from 'react'

import { trackDataLayerEvent } from '../utils'

const FunnelModalContext = createContext({
  isOpen: false,
  openFunnel: () => {},
  closeFunnel: () => {}
})

export const FunnelModalProvider = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  // source identifies which CTA opened the funnel (e.g. 'hero', 'pricing').
  // Fires a single 'funnel_opened' dataLayer event for every entry point.
  const openFunnel = useCallback((source = 'unknown') => {
    trackDataLayerEvent('funnel_opened', { source })
    setIsOpen(true)
  }, [])
  const closeFunnel = useCallback(() => setIsOpen(false), [])
  return (
    <FunnelModalContext.Provider value={{ isOpen, openFunnel, closeFunnel }}>
      {children}
    </FunnelModalContext.Provider>
  )
}

export const useFunnelModal = () => useContext(FunnelModalContext)
